import React, { useEffect } from "react"
import MetaTags from "react-meta-tags"
import { Col, Container, Row, Card, CardBody } from "reactstrap"

import { Link } from "react-router-dom"

import Tile from "components/Services/Tile"

const Services = () => {
    return (
        <React.Fragment>
          <div className="page-content">
            <MetaTags>
              <title>Services | REMA</title>
            </MetaTags>
            <Container fluid>
              <div className="page-title-box">
                <Row className="align-items-center">
                  <Col md={8}>
                    <h6 className="page-title">Services</h6>
                    
                  </Col>
                </Row>
               
               <Row>
                   <Col lg="4">
                       <Tile name="Authorization to use Plastics" link="auth-plastics" />
                   </Col>
                   <Col lg="4">
                       <Tile name="Guidance on Product Disposal" link="guidance-disposal" />
                   </Col>
                   <Col lg="4">
                       <Tile name="Export License" link="licensing-export" />
                   </Col>
               </Row>

               <Row>
                   <Col lg="4">
                       <Tile name="Import License" link="licensing-import" />
                   </Col>
               </Row>
              </div>
            </Container>
          </div>
        </React.Fragment>
      )
}

export default Services